// extracted by mini-css-extract-plugin
export default {"profileOrdersSection":"orders-list_profileOrdersSection__2HP-k"};